<div class="wrapper">
    <div class="cargando-jardin">
        <mat-spinner *ngIf="cargando"></mat-spinner>
    </div>
    <div *ngIf="!cargando" class="contenidoBase">

        <input type="checkbox" id="nav-toggle">
        <div class="sidebar">
            <div class="sidebar-brand profile">
                <div class="junji-profile">
                    <img src="../../../assets/icons/JUNJI__JUNJI-logo.svg">
                </div>
                <ng-template #popContent>
                    <button (click)="cambiarPass()" type="button" class="btn btn-light btn-popover"><i class="fas fa-key"></i> CAMBIAR CLAVE</button>
                    <button (click)="cambiarFoto()" type="button" class="btn btn-light btn-popover"><i class="fas fa-portrait"></i> CAMBIAR FOTO</button>
                    <button (click)="cerrarSesion()" type="button" class="btn btn-light btn-popover"><i class="fas fa-power-off"></i> SALIR</button>
                </ng-template>
                <ng-template #popTitle>Administrador/a</ng-template>
                <button class="image-cropper" placement="bottom" [ngbPopover]="popContent" [popoverTitle]="popTitle">
                        <img [src]="urlProfile" alt="avatar" id="improfile" class="profile-pic" >  
                </button>
                <p class="welcomeText">Bienvenida,</p>
                <p class="userName">Asesor/a</p>
                <p class="userName">Técnico</p>
            </div>
            <!--Secciones-del-tablero-->
            <div class="sidebar-menu">
                <ul>
                   
                    <li>
                        <a (click)="menuVisible('pei-inicio-view')" [className]="menuMostrar==='pei-inicio-view'? 'active' : ''">
                            <img src="../../../assets/icons/JUNJI_autoevaluacion_off.svg" *ngIf="menuMostrar!='pei-inicio-view'">
                            <img src="../../../assets/icons/JUNJI_autoevaluacion_on.svg" *ngIf="menuMostrar==='pei-inicio-view'">
                            <span class="menu-text">PROYECTO EDUCATIVO</span>
                        </a>
                    </li>
                   
                    <li>
                        <a (click)="menuVisible('new-planmejora')" [className]="menuMostrar==='new-planmejora'? 'active' : ''">
                            <img src="../../../assets/icons/JUNJI_plan-mejora_off.svg" *ngIf="menuMostrar!='new-planmejora'">
                            <img src="../../../assets/icons/JUNJI_plan-mejora_on.svg" *ngIf="menuMostrar==='new-planmejora'">
                            <span class="menu-text">PLAN DE MEJORAMIENTO EDUCATIVO</span>
                        </a>
                    </li>

                    <li>
                        <a (click)="menuVisible('pgc-view')" [className]="menuMostrar==='pgc-view'? 'active' : ''">
                            <img src="../../../assets/icons/plan_gestion_Off.svg" *ngIf="menuMostrar!='pgc-view'">
                            <img src="../../../assets/icons/plan_gestion_On.svg" *ngIf="menuMostrar==='pgc-view'">
                            <span class="menu-text">PLAN DE GESTIÓN CONVIVENCIA</span>
                        </a>
                    </li>

                    <li>
                        <a (click)="menuVisible('reglamento-interno-view')" [className]="menuMostrar==='reglamento-interno-view'? 'active' : ''">
                            <img src="../../../assets/icons/reglamento_Off.svg" *ngIf="menuMostrar!='reglamento-interno-view'">
                            <img src="../../../assets/icons/reglamento_On.svg" *ngIf="menuMostrar==='reglamento-interno-view'">
                            <span class="menu-text">REGLAMENTO INTERNO</span>
                        </a>
                    </li>

                </ul>
            </div>

            <div class="sidebar-brand">
                <button (click)="cerrarSesion()" type="button" class="btn btn-light btn-logout"><i class="fas fa-power-off"></i> Salir</button>
            </div>
        </div>


        <div class="main-content">
            <header>
                <div>
                    <p class="title1">
                        ESCRITORIO DIGITAL
                    </p>
                    <p class="title2">
                        del Jardín Infantil
                    </p>
                </div>
                <div class="user-wrapper">
                    <div>

                        <p class="title-jardin">ASESOR/A TÉCNICO: </p>
                        <div class="jardin-name">
                            <p> Asesor/a Técnico </p>
                        </div>


                    </div>
                </div>
            </header>

            <main>
                <app-admin-proyecto-educativo [region]="region" *ngIf="menuMostrar==='pei-inicio-view'"></app-admin-proyecto-educativo>
                <app-new-pme-admin [region]="region" *ngIf="menuMostrar==='new-planmejora'"></app-new-pme-admin> 
                <app-plan-gestion-convivencia-admin [region]="region" *ngIf="menuMostrar==='pgc-view'"></app-plan-gestion-convivencia-admin>
                <app-reglamento-interno-admin [region]="region" *ngIf="menuMostrar==='reglamento-interno-view'"></app-reglamento-interno-admin>
                <app-bibioteca-admin [region]="region" *ngIf="menuMostrar==='biblioteca-view'"></app-bibioteca-admin>
            </main>

        </div>



        <div>
</div>


